import { getTranslation } from "common";
import { useEffect, useState } from "react";
import useTranslations from "./useTranslations";

interface LanguageOption {
    label: string;
    value: string;
}
const useLanguages = () => {

    const [languageOptions, setLanguageOptions] = useState<LanguageOption[]>([]);
    const translations = useTranslations();
    useEffect(() => {
        let languages = getTranslation(translations, "Language");
        languages = languages.replace("(", "");
        languages = languages.replace(")", "");
        languages = languages.replaceAll("'", "");
        languages = languages.replace("Language", "");
        for (let i = 0; i <= 1; i++) {
            const commaIdx = languages.indexOf(",");
            languages = languages.substring(commaIdx + 1);
        }
        const options = languages
            .split(";")
            .map((valueLabel: string) => {
                const [value, label] = valueLabel.split(",");
                return { label, value };
            })
            .filter((x) => x.value);
        setLanguageOptions(options);
    }, [translations]);
    return languageOptions
}
export default useLanguages 